Vendd.Scripts.load(function () {
    var $form = $('.x-contact-form'), $submitButton, form, formData, filedata;
    var VisitorStateCookie = Cookies.get("VisitorState");
    var countryCode = VisitorStateCookie ? LhApp.Function.QueryString.getValueOf("countryCode", VisitorStateCookie) : "";

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        firstName: $("input[name='firstName']", $form).val() ? $("input[name='firstName']", $form).val() : "",
        lastName: $("input[name='lastName']", $form).val() ? $("input[name='lastName']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        phone: $("input[name='phone']", $form).val() ? $("input[name='phone']", $form).val() : "",
        mobilephone: $("input[name='mobilephone']", $form).val() ? $("input[name='mobilephone']", $form).val() : "",
        fax: $("input[name='fax']", $form).val() ? $("input[name='fax']", $form).val() : "",
        address: $("input[name='address']", $form).val() ? $("input[name='address']", $form).val() : "",
        message: $("textarea[name='message']", $form).val() ? $("textarea[name='message']", $form).val() : "",
        newsletter: false,
        subject: $("select[name='subject']", $form).val() ? $("select[name='subject']", $form).val() : "",
        reCaptchaCode: "",
        contactFileUpload: "",
        currentCountryCode: ""
    };

    // reCAPTCHA
    var captchaId = "contactCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    // file upload
    var $fileUploadElement = $form.find("#cwfileupload");
    var fileUploadEnabled = $fileUploadElement.length > 0 ? true : false;
    var invalidUpload = false;

    var subjectEnabled = $('.x-contact-form .form-row select[name=subject]').length > 0;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
            //accessibility fix
            $('#g-recaptcha-response').attr('aria-label', 'recaptcha response');
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.validateFileUpload = function () {
        if (!fileUploadEnabled)
            return true;

        if (invalidUpload)
            return false;

        if ($("#cwfileupload", $form).data("mandatoryfileupload") === "True" && $("#cwfileupload", $form).get(0).files.length === 0) {
            $('.cwfileupload-required', $form).show();
            $('.form-row.file', $form).addClass('with-error');

            return false;
        }

        return true;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "Contact_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            $('html,body').animate({ scrollTop: $('.js-success', $form).offset().top - 100 }, 400);

            /* Track Contact */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'Contact');
                }
            }
            /* END Track Contact */

            form.removeRecaptcha();
            form.reset();
        } else {
            $('.js-error', $form).show();
            form.resetRecaptcha();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };
        
    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Contact Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            if (filedata)
                filedata.submit();
            else
                form.submit();
        }
    };

    form.submit = function () {
        form.loading(true);

        if ($('#chkNewsletter').length > 0) formData.newsletter = $('#chkNewsletter').prop("checked");


        $('input:not([type="checkbox"],[type="file"]), textarea:not([name="g-recaptcha-response"]),select', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.Contact.Messages.Submit(
            formData.email,
            formData.firstName,
            formData.lastName,
            formData.message,
            formData.newsletter,
            formData.address,
            formData.phone,
            formData.mobilephone,
            formData.fax,
            '', '',
            formData.reCaptchaCode,
            subjectEnabled ? formData.subject : 0,
            formData.contactFileUpload,
            formData.currentCountryCode
        ));
    };

    form.reset = function () {
        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="mobilephone"]', $form).val("");
        $('input[name="fax"]', $form).val("");
        $('input[name="address"]', $form).val("");
        $('textarea[name="message"]', $form).val("");
        $('select[name="subject"]', $form).val("");
        $('input[name="PrivacyPolicy"]', $form).prop('checked', false);
        cf.reset();
    };

    form.clearUploadErrors = function () {
        $('.cwfileupload-required', $form).hide();
        $('.cwfileupload-invalid', $form).hide();
        $('.cwfileupload-exceeds-max-size', $form).hide();
        $('.form-row.file', $form).removeClass('with-error');
    };

    form.submitSelector = function () {
        if (filedata)
            filedata.submit();
        else
            form.submit();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();
        var val3 = form.validateFileUpload();


        if (val1 && val2 && val3) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                if (filedata)
                    filedata.submit();
                else
                    form.submit();
            }
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error').first().offset().top - 100 }, 400);
            }
        }

        initialValidation = true;
    });

    $form.on('click', '.js-reset-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.reset();
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                cf.validateField("email");
            }

            if ($(this).attr('name') === "phone") {
                cf.validateField("phone");
            }

            if ($(this).attr('name') === "mobile") {
                cf.validateField("mobile");
            }
        }

        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', 'select[name]', function (e) {
        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        cf.validate(fieldName);
    };

    //init validation options
    var validationOptions = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('div.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        validationOptions.email = { ...validationOptions.email, ...{ isEmail: 'email-invalid' } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } } };
        } else {
            validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
        }
    }
    //add mobile phone validation
    if ($('input[name="mobilephone"]', $form).length > 0) {
        validationOptions.mobilephone = validationOptions.mobilephone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isValidPhoneLocalized: { validator: 'mobilephone-invalid', config: { type: 'mobile' } } } };
        } else {
            validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isPhoneNumber: 'mobilephone-invalid' } };
        }
    }

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                cf = $form.data('validationEngine');
                cf.validate('phone');
            });
        }
        if ($('input[name="mobilephone"]', $form).length > 0) {
            $('input[name="mobilephone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.mobilephone = $(this).val();
                cf = $form.data('validationEngine');
                cf.validate('mobilephone');
            });
        }
    }

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox({
            touch: false,
            autoFocus: false
        });
    }

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');

        cf.validate(fieldName);
    });

    $('.cwfileupload', $form).on('click', function () {
        $('.cwuploaded-file', $form).hide();
        $('.cwuploaded-file .text', $form).text('');
    });

    $('.cwfileupload', $form).fileupload({
        dataType: 'json',
        url: '/Engine/UploadContactFiles',
        autoUpload: false,
        replaceFileInput: false,
        fileInput: $("input:file"),
        multiple: false,
        singleFileUploads: true,
        done: function (e, data) {
            form.submit();
        },
        fail: function (e, data) {
            $('.cwfileupload-invalid', $form).show();
        },
        add: function (e, data) {

            form.clearUploadErrors();
            formData.contactFileUpload = "";

            var maxFileSize = $("#cwfileupload", $form).data("maxfilesize");

            var fileTypes = $("#cwfileupload", $form).data("acceptfiletypes");
            if (fileTypes) {
                var acceptFileTypes = "(\.|\/)(" + fileTypes + ")$";
                acceptFileTypes = new RegExp(acceptFileTypes, "i");
            }

            var extractExtension = /(?:\.([^.]+))?$/;

            if (acceptFileTypes && data.originalFiles[0]['type'].length && !acceptFileTypes.test(extractExtension.exec(data.originalFiles[0].name)[0])) {
                invalidUpload = true;
                $('.cwfileupload-invalid', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            }
            else if (data.originalFiles[0]['size'] > maxFileSize) {
                invalidUpload = true;
                $('.cwfileupload-exceeds-max-size', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            }
            else {
                invalidUpload = false;
                $('.cwuploaded-file', $form).show();
                $('.cwuploaded-file .text', $form).text(data.files[0].name);
                $('.cwuploaded-file .js-delete-file', $form).on('click', function (event) {
                    event.preventDefault();

                    form.clearUploadErrors();

                    $('.cwfileupload', $form).val('');
                    $('.cwuploaded-file', $form).hide();
                    $('.cwuploaded-file .text', $form).empty();

                    data.files.length = 0;

                    filedata = null;
                    formData.contactFileUpload = "";
                });
                filedata = data;
                formData.contactFileUpload = data.files[0].name;
                formData.currentCountryCode = countryCode;
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Contact.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Contact.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submitSelector);
});

